import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { useStyleStore } from "@vcl";

export default class ActiveIconColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Active Icon Color",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      colorContext: "Fonts",
      emptyLabel: "Same as Like",
    },
  };

  static defaultValue = {
    value: "error",
    source: "theme.font",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    if (!configValue?.source) {
      return "";
    }
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static getLogValue(value) {
    return value?.value ?? "";
  }
}
